import React from 'react';
import './toggle.css';

const Toggle = ({ active, setHandler, captionLeft, captionRight }) => {
    return (
        <div className="toggle">
            <div
                className={ `toggle__caption ${ active ? 'toggle__caption--active' : '' }` }
                onClick={ () => setHandler(true) }
            >{ captionLeft }</div>
            <div className={ `toggle__ico ${ !active ? 'toggle__ico--active' : '' } `}
                 onClick={ () => setHandler(!active) }
            />
            <div
                className={ `toggle__caption ${ !active ? 'toggle__caption--active' : '' }` }
                onClick={ () => setHandler(false) }
            >{ captionRight }</div>
        </div>
    );
};

export default Toggle;